// src/components/NavBar.js
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn, FaTiktok } from 'react-icons/fa';
import MalzookLogo from '../../assets/images/Malzook.png';


const Footer = () => {

    return (
      <footer className="footer">
        <div className="container">
          <div className="row">
           
            <div className="col-md-4 text-start">
              <p>&copy; {new Date().getFullYear()} Kl!q</p>
            </div>
  
            <div className="col-md-4 text-center social-icons">
              <a href="https://web.facebook.com/KLIQGH"><FaFacebookF /></a>
              <a href="https://www.instagram.com/kliq_gh/"><FaInstagram /></a>
              <a href="https://www.tiktok.com/@kliq_gh"><FaTiktok /></a>
              {/* <a href="#"><FaLinkedinIn /></a> */}
            </div>
  
            <div className="col-md-4 text-end">
              {/* <a href="#/privacy-policy">Privacy Policy</a> */}
              <Link to="/privacy-policy">Privacy Policy</Link>
              <a href="#">Terms & Conditions</a>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  export default Footer;